import { render, staticRenderFns } from "./newHome1.vue?vue&type=template&id=458a3d6c&scoped=true&"
import script from "./newHome1.vue?vue&type=script&lang=js&"
export * from "./newHome1.vue?vue&type=script&lang=js&"
import style0 from "./newHome1.vue?vue&type=style&index=0&id=458a3d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458a3d6c",
  null
  
)

export default component.exports